import React from 'react';

export const FloorPlanEditorCanvas = ({
  canvasRef,
  width,
  height,
  scale,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseLeave,
}) => {
  return (
    <div className="flex-1 bg-white rounded-xl shadow-sm p-4" data-testid="floorplan-editor-canvas-wrapper">
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        className="border border-gray-300 rounded-lg cursor-crosshair mx-auto block"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        data-testid="floorplan-editor-canvas"
      />
      <div className="text-center mt-4 text-sm text-gray-500" data-testid="floorplan-editor-canvas-scale">
        Tamanho: {width / scale}m × {height / scale}m • 1 quadrado = 1 metro
      </div>
    </div>
  );
};
